var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutWork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4981 60.551L67.4823 41.8896C68.6111 40.849 68.3466 38.9969 66.9885 38.2914L50.673 29.8602C49.3148 29.1547 47.6568 30.019 47.4628 31.5359L43.794 58.6284C43.5118 60.6921 45.9812 61.962 47.4981 60.551Z",
    fill: "#236F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8442 2.46743L52.8599 21.1289C51.731 22.1695 51.9956 24.0215 53.3538 24.7271L69.6693 33.1582C71.0274 33.8637 72.6853 32.9995 72.8794 31.4826L76.5482 4.39C76.8304 2.32632 74.3611 1.05636 72.8442 2.46743Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.995 32.8055C84.239 42.4008 84.9975 55.0828 78.8946 65.6834C70.3224 80.5878 51.3963 85.8088 36.4037 77.5188L30.7419 89.4952C29.7012 91.6823 27.0201 92.529 24.9388 91.3119C23.5983 90.5359 22.8575 89.1425 22.8575 87.7138C22.8575 86.9024 23.0869 86.091 23.5984 85.3678L31.3769 74.0616C19.9119 64.4487 16.6312 47.7099 24.3568 34.2871C28.9428 26.3146 36.492 21.1113 44.8173 19.2593",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7556 39.3318C79.0187 46.7575 78.8424 55.5767 74.4857 63.126C67.2187 75.7374 51.1148 80.0941 38.4858 72.8271C25.8567 65.5601 21.5177 49.4562 28.7847 36.8272C32.0654 31.13 37.1453 27.1261 42.8954 25.0977",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1614 86.4759H9.40206C5.02775 86.4759 1.5 82.9306 1.5 78.5739V28.3751C1.5 24.0008 5.04538 20.4731 9.40206 20.4731H22.1546",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7382 20.4551H81.1547C85.529 20.4551 89.0566 24.0004 89.0566 28.3571V78.5558C89.0566 82.9301 85.5113 86.4578 81.1547 86.4578H45.5781",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 92,
    fill: "white",
    transform: "translate(0 0.870605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutWork2);
export default __webpack_public_path__ + "static/media/aboutWork2.83f623501a7cfcbfa55dbf68c6669b8d.svg";
export { ForwardRef as ReactComponent };